import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ExpensePolicyPerDiemStateClass } from './interfaces/expensePolicyPerDiemStateClass';
import { sortData } from '../../../common/timeLiveFunction';

const initialState: ExpensePolicyPerDiemStateClass = {
    isLoading: false,
    status: 'idle',
    expensePolicyPerDiemDetailList: [],
    expensePolicyPerDiemTypeList: [],
    AccountExpensePolicyPerDiemId: 0,
    AccountExpensePolicyPerDiemLocationId: 0,
    selectedRecord: {},
    isReload: false,
    DefaultExpenseCatId: 0,
    AccountExpensePolicyPerDiemLocationRateId: 0,
    ForDefaultRate: true,
    IsGetId:false    ,
    AccountExpensePolicyPerDiemLocationId1 :0,
    isListUpdated:false,
    sortOrder: 'asc',
    sortColumn: 'AccountLocation',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        globalState: any;
        expensePolicyPerDiem: ExpensePolicyPerDiemStateClass;
    },
    
}

export const GetDataForExpensePolicyPerDiemRateAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'expensePolicyPerDiem/GetDataForExpensePolicyPerDiemRate',
    async (arg, thunkApi) => {
        const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/PolicyRate/'+ arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
        const json = await response.json();
        return json;
    }
)
export const addDefaultCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/addDefaultCategory',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyId,DefaultExpenseCategoryPerDiemId} = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/Default', 'POST', 
            {AccountExpensePolicyId:AccountExpensePolicyId , DefaultExpenseCategoryPerDiemId:DefaultExpenseCategoryPerDiemId },
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const addPerDiemLocationsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/addPerDiemLocations',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyPerDiemId,PerDiemLocationName,EffectiveDate, CountryId, CityId, IsDefaultRate} = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/Location', 'POST', 
            { AccountExpensePolicyPerDiemId: AccountExpensePolicyPerDiemId, SystemCountryId: CountryId, SystemCityId: CityId, PerDiemLocationName: PerDiemLocationName, EffectiveDate: EffectiveDate, IsDefaultRate: IsDefaultRate },
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
export const addPerDiemLocationRatesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/addPerDiemLocationRates',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/LocationRate', 'POST', arg,
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    
    export const UpdateDefaultCategoryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/UpdateDefaultCategory',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyPerDiemId, AccountExpensePolicyId, DefaultExpenseCategoryPerDiemId } = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/Default/' + AccountExpensePolicyPerDiemId, 'PUT', 
            { AccountExpensePolicyPerDiemId: AccountExpensePolicyPerDiemId, AccountExpensePolicyId: AccountExpensePolicyId, DefaultExpenseCategoryPerDiemId: DefaultExpenseCategoryPerDiemId },
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const GetAccountExpensePolicyPerDiemIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/GetAccountExpensePolicyPerDiemId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/PerDiem/'+ arg, 'Get','',
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const GetAccountExpensePolicyPerDiemRateForAddEditForDefaultAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/GetAccountExpensePolicyPerDiemRateForAddEdit',
        async (arg, thunkApi) => {           
            const{AccountExpensePolicyPerDiemLocationRateId} = arg;
            const { accountBaseCurrencyId } = thunkApi.getState().globalState;            
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/ForAddEdit/'+ AccountExpensePolicyPerDiemLocationRateId, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            const modifiedData = json.data.map((item: any) => ({
                ...item,
                SystemCurrencyId: accountBaseCurrencyId
            }));
           return modifiedData;         
            //return json;         
        }
    )

    export const GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/GetAccountExpensePolicyPerDiemRateForLocationRateAddEdit',
        async (arg, thunkApi) => {
    
            const{AccountExpensePolicyPerDiemLocationRateId} = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/ForAddEdit/'+ AccountExpensePolicyPerDiemLocationRateId, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
            
        }
        
    )

    export const GetDataForPerdiemTypesListForAddLocationRatesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/GetDataForPerdiemTypesListForAddLocationRates',
        async (arg, thunkApi) => {
            const{AccountExpensePolicyId,CountryId,CityId} = arg;
            const { accountBaseCurrencyId } = thunkApi.getState().globalState;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/GetDataForPerdiemTypesListForAddLocationRates/'+ AccountExpensePolicyId + '/' + CountryId + '/' + CityId , 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            const modifiedData = json.data.map((item: any) => ({
                ...item,
                SystemCurrencyId: accountBaseCurrencyId
            }));
           return modifiedData;            
            // return json; 
        }        
    )

    export const GetAccountExpensePolicyPerDiemForEditAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/GetAccountExpensePolicyPerDiemForEdit',
        async (arg, thunkApi) => {
            const{AccountExpensePolicyPerDiemLocationRateId} = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/ForAddEdit/'+ arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;            
        }
        
    )

 
    
    export const UpdatePerDiemLocationsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/UpdatePerDiemLocations',
        async (arg, thunkApi) => {            
            const {AccountExpensePolicyPerDiemLocationId, AccountExpensePolicyPerDiemId, CountryId,CityId, PerDiemLocationName,EffectiveDate, IsDefaultRate } = arg;
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/Location/' + AccountExpensePolicyPerDiemLocationId, 'PUT',
            {AccountExpensePolicyPerDiemId: AccountExpensePolicyPerDiemId, SystemCountryId: CountryId, SystemCityId: CityId, PerDiemLocationName: PerDiemLocationName, EffectiveDate: EffectiveDate, IsDefaultRate: IsDefaultRate },
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const UpdatePerDiemLocationRatesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyPerDiem/UpdatePerDiemLocationRates',
        async (arg, thunkApi) => {
            const {AccountExpensePolicyPerDiemLocationRateId, AccountExpensePolicyPerDiemTypeId, PerDiemRate, SystemCurrencyId,IsDefault} = arg[0];
            console.log('UpdatePerDiemLocationRates', arg[0])
            const response = await fetchAPI('api/V2/ExpensePolicyPerDiem/LocationRate/' + AccountExpensePolicyPerDiemLocationRateId, 'PUT',
            {AccountExpensePolicyPerDiemTypeId: AccountExpensePolicyPerDiemTypeId, PerDiemRate: PerDiemRate, SystemCurrencyId: SystemCurrencyId, IsDefault: IsDefault },
                true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const DeleteAccountPerDiemLocationRateAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'expensePolicyRule/DeleteAccountPerDiemLocationRate',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ExpensePolicyPerDiem/LocationRate/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordExpensePolicyPerDiemAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordExpensePolicyPerDiem",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/ExpensePolicyPerDiem/DeleteAllSelectedRecordExpensePolicyPerDiem/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        }
    )

export const expensePolicyPerDiemSlice = createSlice({
    name: 'expensePolicyPerDiem',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
            state.expensePolicyPerDiemTypeList = [];
        },
        resetDefaultCategory: (state, action) => {
            state.DefaultExpenseCatId = action.payload;
        },
        updateForDefaultRate: (state, action) => {
            state.ForDefaultRate = action.payload;
        },
        setValuesAccountExpensePolicyPerDiemRate: (state, action) => {            
            console.log('action.payload.PerDiemRate',action.payload.PerDiemRate)
            const index = state.expensePolicyPerDiemTypeList.findIndex((item) => item.AccountExpensePolicyPerDiemTypeId === action.payload.Id);
            const newArray = [...state.expensePolicyPerDiemTypeList];          
            if ('PerDiemRate' in action.payload) {
                newArray[index] = { ...newArray[index], PerDiemRate: action.payload.PerDiemRate != '' ? action.payload.PerDiemRate : 0};               
            } else {
                newArray[index] = { ...newArray[index], SystemCurrencyId: action.payload.SystemCurrencyId , CurrencyCode: action.payload.CurrencyCode };
            }
             state.expensePolicyPerDiemTypeList = newArray;
        },

        setValuesPerDiemLocationCountryIdCityId: (state, action) => {        
        },
        
        UpdateAccountExpensePolicyPerDiemLocationId: (state, action) => {
            state.AccountExpensePolicyPerDiemLocationId = action.payload
            state.isReload = false;    
        },
        UpdateAccountExpensePolicyPerDiemLocationRateId: (state, action) => {
            state.AccountExpensePolicyPerDiemLocationRateId = action.payload
            state.isReload = false;    
        },
        resetAccountExpensePolicyperDiemId: (state, action) => {
            state.AccountExpensePolicyPerDiemId = action.payload;
        },
        checkedState: (state, action) => {
            const currentindex = state.expensePolicyPerDiemDetailList.findIndex((item) => item.AccountExpensePolicyPerDiemLocationRateId == action.payload);
            const newArray = [...state.expensePolicyPerDiemDetailList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.expensePolicyPerDiemDetailList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.expensePolicyPerDiemDetailList.findIndex((item) => item.AccountExpensePolicyPerDiemLocationRateId == action.payload);
            const newArray = [...state.expensePolicyPerDiemDetailList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.expensePolicyPerDiemDetailList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.expensePolicyPerDiemDetailList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.expensePolicyPerDiemDetailList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.expensePolicyPerDiemDetailList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.expensePolicyPerDiemDetailList = newArray;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.expensePolicyPerDiemDetailList;
            state.expensePolicyPerDiemDetailList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetDataForExpensePolicyPerDiemRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(GetDataForExpensePolicyPerDiemRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.data).length === 0) {
                    state.expensePolicyPerDiemDetailList = [];
                } else {
                    state.expensePolicyPerDiemDetailList = payload.data;
                    state.expensePolicyPerDiemDetailList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(GetDataForExpensePolicyPerDiemRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(GetAccountExpensePolicyPerDiemIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(GetAccountExpensePolicyPerDiemIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.expensePolicyPerDiemDetailList = payload;
                state.isReload = false;
            })
            .addCase(GetAccountExpensePolicyPerDiemIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase( GetAccountExpensePolicyPerDiemRateForAddEditForDefaultAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase( GetAccountExpensePolicyPerDiemRateForAddEditForDefaultAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                payload.map((item : any) => {
                    item.CurrencyCode = '';
                    item.PerDiemRate = 0;
                    item.AccountExpensePolicyPerDiemLocationId = 0;
                    item.IsDefault = true;
                    delete item.AccountId;
                    delete item.CreatedByEmployeeId;
                    delete item.CreatedOn;
                    delete item.IsDeleted;
                    delete item.MasterAccountExpensePolicyPerDiemTypeId;
                    delete item.ModifiedByEmployeeId;
                    delete item.ModifiedOn;
                })
                
                state.expensePolicyPerDiemTypeList  = payload.filter((item1: { AccountExpensePolicyPerDiemTypeId: any; }) => 
                !state.expensePolicyPerDiemDetailList.find((item2: { AccountExpensePolicyPerDiemTypeId: any; PerDiemLocationName : any }) => 
                (item2.AccountExpensePolicyPerDiemTypeId === item1.AccountExpensePolicyPerDiemTypeId)
                && (item2.PerDiemLocationName === 'Default Rate')
                ) );

                state.isReload = false;

            })
            .addCase( GetAccountExpensePolicyPerDiemRateForAddEditForDefaultAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase( GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase( GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                payload.data.map((item : any) => {
                    item.SystemCurrencyId = 0;
                    item.CurrencyCode = '';
                    item.PerDiemRate = 0;
                    item.AccountExpensePolicyPerDiemLocationId = 0;
                    item.IsDefault = false;
                    delete item.AccountId;
                    delete item.CreatedByEmployeeId;
                    delete item.CreatedOn;
                    delete item.IsDeleted;
                    delete item.MasterAccountExpensePolicyPerDiemTypeId;
                    delete item.ModifiedByEmployeeId;
                    delete item.ModifiedOn;
                })
                state.expensePolicyPerDiemTypeList = payload.data;
                state.isReload = false;

            })
            .addCase( GetAccountExpensePolicyPerDiemRateForAddEditLocationRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            
            .addCase( GetAccountExpensePolicyPerDiemForEditAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })

            .addCase( GetAccountExpensePolicyPerDiemForEditAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.expensePolicyPerDiemTypeList = payload.data;
                state.selectedRecord = payload.data[0];

            })
            .addCase( GetAccountExpensePolicyPerDiemForEditAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            
            .addCase( GetDataForPerdiemTypesListForAddLocationRatesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = false;

            })

            .addCase( GetDataForPerdiemTypesListForAddLocationRatesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                payload.map((item : any) => {
                    item.PerDiemRate = 0;
                    item.AccountExpensePolicyPerDiemLocationId = 0;
                    item.IsDefault = false;
                    delete item.AccountId;
                    delete item.CreatedByEmployeeId;
                    delete item.CreatedOn;
                    delete item.IsDeleted;
                    delete item.MasterAccountExpensePolicyPerDiemTypeId;
                    delete item.ModifiedByEmployeeId;
                    delete item.ModifiedOn;
                })
              
                state.expensePolicyPerDiemTypeList = payload;
                state.isReload = false;
            })
            .addCase( GetDataForPerdiemTypesListForAddLocationRatesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })


            .addCase(addDefaultCategoryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addDefaultCategoryAsync.fulfilled, (state, action) => {
                
                state.status = 'idle';
                state.isLoading = false;
                state.AccountExpensePolicyPerDiemId = action.payload.id;
                state.isReload = true;
            })
            .addCase(addDefaultCategoryAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(addPerDiemLocationsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addPerDiemLocationsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.AccountExpensePolicyPerDiemLocationId = payload.id;
                state.expensePolicyPerDiemTypeList.map((item)=>{
                    item.AccountExpensePolicyPerDiemLocationId = payload.id;
                    item.IsDefault = true
                });
                state.isReload = true;
                state.isListUpdated = true;
            })
            .addCase(addPerDiemLocationsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addPerDiemLocationRatesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addPerDiemLocationRatesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.AccountExpensePolicyPerDiemLocationId = 0;
                state.isReload = true;
                state.isListUpdated = false;
            })
            .addCase(addPerDiemLocationRatesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.AccountExpensePolicyPerDiemLocationId = 0;               
            })

            .addCase(UpdatePerDiemLocationsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(UpdatePerDiemLocationsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.AccountExpensePolicyPerDiemLocationId = payload.id;
                state.AccountExpensePolicyPerDiemLocationId1 =payload.id;
                state.expensePolicyPerDiemTypeList.map((item)=>{
                    item.AccountExpensePolicyPerDiemLocationId = payload.id;
                    item.IsDefault = true
                });
                state.isReload = true;
            })
            .addCase(UpdatePerDiemLocationsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(UpdatePerDiemLocationRatesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(UpdatePerDiemLocationRatesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;

                
            })
            .addCase(UpdatePerDiemLocationRatesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

            .addCase(DeleteAccountPerDiemLocationRateAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(DeleteAccountPerDiemLocationRateAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(DeleteAccountPerDiemLocationRateAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            

            .addCase(deleteAllSelectedRecordExpensePolicyPerDiemAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAllSelectedRecordExpensePolicyPerDiemAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordExpensePolicyPerDiemAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

    }
})

export const {
    resetSelectedRecordObjectInState,resetDefaultCategory,updateForDefaultRate, setValuesAccountExpensePolicyPerDiemRate,
    setValuesPerDiemLocationCountryIdCityId,UpdateAccountExpensePolicyPerDiemLocationId, UpdateAccountExpensePolicyPerDiemLocationRateId,  
    resetAccountExpensePolicyperDiemId,checkedState, unCheckedState, checkedAllState, unCheckedAllState,updatePagination,updateSorting
} = expensePolicyPerDiemSlice.actions
export const expensePolicyPerDiemStateClass = (state: RootState) => state.expensePolicyPerDiem
export default expensePolicyPerDiemSlice.reducer